// import { yupResolver } from '@hookform/resolvers/yup';
// import {
//   Alert,
//   Autocomplete,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   InputAdornment,
//   InputLabel,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useMemo, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import { FaCalendarAlt, FaCheckCircle, FaFileAlt, FaTools, FaUndo, FaUser } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { OutreachForm as OutreachFormType } from 'slices/NdisSlices/carporateServices/feedbackAndManagementListSlice';
// import {
//   clearOutreachFormState,
//   OutreachFormData,
//   submitOutreachForm
// } from 'slices/NdisSlices/reportAllForms/outreachFormSlice';
// import { fetchParticipantsList } from 'slices/HomeTilesSlices';
// import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
// import * as yup from 'yup';

// // Validation schemas
// const generalSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_outreach: yup.string().required('Date of outreach is required'),
//     client_name: yup.string().required('Client name is required'),
//     support_worker_name: yup.string().required('Support worker name is required'),
//     service_type: yup.string().required('Type of outreach service is required'),
//     other_service_type: yup.string().when('service_type', {
//       is: 'Other',
//       then: (schema) => schema.required('Please specify other service type'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     description: yup.string().required('Description of outreach is required'),
//     goals: yup.string().required('Goals of outreach are required'),
//     was_successful: yup.string().required('Please specify if outreach was successful'),
//     explanation: yup.string().when('was_successful', {
//       is: 'No',
//       then: (schema) => schema.required('Please explain why outreach was not successful'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     support_worker_name_details: yup.string().optional().default(''),
//     signature: yup.string().optional().default(''),
//     date_completed: yup.string().optional().default(''),
//     client_email: yup.string().optional().default(''),
//     group_id: yup.string().optional().default(''),
//     service_name_id: yup.string().optional().default(''),
//     notes: yup.string().optional().default(''),
//     action_taken: yup.string().optional().default('')
//   })
//   .required() as yup.ObjectSchema<OutreachFormData>;

// const officeSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_outreach: yup.string().optional().default(''),
//     client_name: yup.string().optional().default(''),
//     support_worker_name: yup.string().optional().default(''),
//     service_type: yup.string().optional().default(''),
//     other_service_type: yup.string().optional().default(''),
//     description: yup.string().optional().default(''),
//     goals: yup.string().optional().default(''),
//     was_successful: yup.string().optional().default(''),
//     explanation: yup.string().optional().default(''),
//     support_worker_name_details: yup.string().required('Support worker name (details) is required'),
//     signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     client_email: yup.string().optional().default(''),
//     group_id: yup.string().optional().default(''),
//     service_name_id: yup.string().optional().default(''),
//     notes: yup.string().optional().default(''),
//     action_taken: yup.string().optional().default('')
//   })
//   .required() as yup.ObjectSchema<OutreachFormData>;

// interface Client {
//   label: string;
//   id: number;
//   email: string;
// }

// interface StaffMember {
//   name: string;
//   email: string;
// }

// interface OutreachFormProps {
//   initialData?: OutreachFormType;
//   onClose?: () => void;
// }

// const OutreachForm: React.FC<OutreachFormProps> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.outreachForm);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Redux state data
//   const selectedProjectId = useTypedSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useTypedSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const participantsList = useTypedSelector(
//     (state: RootState) => state?.homeTilesServices?.participants
//   ) || { participants_list: [] };
//   const supportWorkers = useTypedSelector((state: RootState) =>
//     (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
//       name: worker.name,
//       email: worker.email || '' // Fallback to empty string if email is missing
//     }))
//   ) as StaffMember[];
//   const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);

//   // Local storage data
//   const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//     label?: string;
//     id?: number;
//     email?: string;
//   };
//   const loginInfo = localStorage.getItem('user-details');
//   const userDetails = loginInfo ? JSON.parse(loginInfo) : null;

//   // Prepare clients list, ensuring selectedClient is included
//   const clientsList = useMemo(() => {
//     const list =
//       participantsList.participants_list?.map(
//         (participant: { name: string; email: string }, index: number) => ({
//           label: participant.name || `Client ${index + 1}`,
//           id: index + 1,
//           email: participant.email
//         })
//       ) || [];
//     // Add selectedClient if it exists and is not already in the list
//     if (
//       selectedClient?.label &&
//       selectedClient?.email &&
//       !list.some((client) => client.label === selectedClient.label)
//     ) {
//       list.push({
//         label: selectedClient.label,
//         id: selectedClient.id || list.length + 1,
//         email: selectedClient.email
//       });
//     }
//     return list;
//   }, [participantsList.participants_list, selectedClient]);

//   // Find default client and support worker for Autocomplete
//   const defaultClient =
//     clientsList.find(
//       (client) => client.label === (initialData?.client_name || selectedClient?.label)
//     ) || null;
//   const defaultSupportWorker =
//     supportWorkers.find(
//       (worker) => worker.name === (initialData?.support_worker_name || userDetails?.name)
//     ) || null;
//   const defaultSupportWorkerDetails =
//     supportWorkers.find((worker) => worker.name === (initialData?.sw_name || userDetails?.name)) ||
//     null;

//   // State for client and staff loading/errors
//   const [isClientsLoading, setIsClientsLoading] = useState(false);
//   const [clientsError, setClientsError] = useState<string | null>(null);
//   const [staffError, setStaffError] = useState<string | null>(null);

//   // Fetch participants
//   useEffect(() => {
//     if (
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       setIsClientsLoading(true);
//       dispatch(
//         fetchParticipantsList({
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           nested_component_id: location.pathname,
//           email: userDetails.email,
//           roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//           client_name: ''
//         })
//       )
//         .unwrap()
//         .then(() => {
//           setIsClientsLoading(false);
//         })
//         .catch((error: unknown) => {
//           setIsClientsLoading(false);
//           setClientsError('Failed to load clients. Please try again later.');
//         });
//     } else {
//       setIsClientsLoading(false);
//     }
//   }, [selectedProjectId]);

//   // Fetch staff
//   useEffect(() => {
//     if (
//       selectedClient?.label &&
//       selectedProjectId &&
//       selectedServiceTitle &&
//       userDetails?.email &&
//       userDetails?.role?.length > 0
//     ) {
//       const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
//       const payload = {
//         group_id: selectedProjectId,
//         service_name_id: selectedServiceTitle.replace(' ', '_'),
//         nested_component_id: 'Staff_List',
//         email_loggedIn_userEmail: userDetails.email,
//         roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
//         client_name: selectedClient.label?.replace(' ', '_') || '',
//         approved_user: approvedUser,
//         curr_loggIn_userRoles: userDetails?.name || ''
//       };
//       dispatch(fetchStaffByRoles(payload)).catch((error: unknown) => {
//         setStaffError('Failed to load support workers. Please try again later.');
//       });
//     }
//   }, [selectedClient?.label]);

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'feedbacks';
//   const outreachId = initialData?.id || undefined;

//   const isGeneralRoute = location.pathname === '/outreach';
//   const isOfficeRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'feedbacks';

//   // Check if Office Use Only form is already filled
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   useEffect(() => {
//     if (isOfficeRoute && initialData) {
//       const isFilled = [
//         initialData.sw_name,
//         initialData.sw_signature,
//         initialData.date_completed,
//         initialData.notes,
//         initialData.action_taken
//       ].some((field) => field && field.trim() !== '');
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isOfficeRoute]);

//   // Current datetime as default
//   const defaultDateTime = new Date().toISOString().split('T')[0];

//   // Use separate useForm hooks for each route
//   const generalForm = useForm<OutreachFormData>({
//     resolver: yupResolver<OutreachFormData>(generalSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_outreach: initialData?.date_of_outreach || defaultDateTime,
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
//       service_type: initialData?.type_of_outreach || '',
//       other_service_type:
//         initialData?.type_of_outreach &&
//         !['Home Visit', 'Community Support'].includes(initialData.type_of_outreach)
//           ? initialData.type_of_outreach
//           : '',
//       description: initialData?.description || '',
//       goals: initialData?.goals || '',
//       was_successful: initialData?.successful || '',
//       explanation: initialData?.explanation || '',
//       support_worker_name_details: '',
//       signature: '',
//       date_completed: '',
//       client_email: selectedClient?.email || '',
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       notes: '',
//       action_taken: ''
//     }
//   });

//   const officeForm = useForm<OutreachFormData>({
//     resolver: yupResolver<OutreachFormData>(officeSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_outreach: initialData?.date_of_outreach || '',
//       client_name: initialData?.client_name || selectedClient?.label || '',
//       support_worker_name: initialData?.support_worker_name || '',
//       service_type: initialData?.type_of_outreach || '',
//       other_service_type:
//         initialData?.type_of_outreach &&
//         !['Home Visit', 'Community Support'].includes(initialData.type_of_outreach)
//           ? initialData.type_of_outreach
//           : '',
//       description: initialData?.description || '',
//       goals: initialData?.goals || '',
//       was_successful: initialData?.successful || '',
//       explanation: initialData?.explanation || '',
//       support_worker_name_details: initialData?.sw_name || userDetails?.name || '',
//       signature: initialData?.sw_signature || '',
//       date_completed: initialData?.date_completed || defaultDateTime,
//       client_email: selectedClient?.email || '',
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       notes: initialData?.notes || '',
//       action_taken: initialData?.action_taken || ''
//     }
//   });

//   const service_type = generalForm.watch('service_type');
//   const was_successful = generalForm.watch('was_successful');

//   // Update client_email when client_name changes
//   useEffect(() => {
//     const selectedClientFromList = clientsList.find(
//       (client) => client.label === generalForm.getValues('client_name')
//     );
//     if (selectedClientFromList) {
//       generalForm.setValue('client_email', selectedClientFromList.email);
//     }
//   }, [generalForm.watch('client_name'), clientsList, generalForm]);

//   useEffect(() => {
//     const selectedClientFromList = clientsList.find(
//       (client) => client.label === officeForm.getValues('client_name')
//     );
//     if (selectedClientFromList) {
//       officeForm.setValue('client_email', selectedClientFromList.email);
//     }
//   }, [officeForm.watch('client_name'), clientsList, officeForm]);

//   const onSubmitGeneral = async (data: OutreachFormData) => {
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     const payload: OutreachFormData = {
//       ...data,
//       client_email,
//       support_worker_name_details: '',
//       signature: '',
//       date_completed: '',
//       notes: '',
//       action_taken: ''
//     };

//     dispatch(submitOutreachForm({ formData: payload }))
//       .unwrap()
//       .then(() => {
//         generalForm.reset();
//         setTimeout(() => dispatch(clearOutreachFormState()), 5000);
//       });
//   };

//   const onSubmitOffice = async (data: OutreachFormData) => {
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     const payload: OutreachFormData = {
//       id: outreachId,
//       ...data,
//       client_email
//     };

//     dispatch(submitOutreachForm({ formData: payload, initialData }))
//       .unwrap()
//       .then(() => {
//         officeForm.reset();
//         setTimeout(() => dispatch(clearOutreachFormState()), 5000);
//         if (onClose) {
//           onClose();
//         }
//       });
//   };

//   const handleResetGeneral = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     generalForm.reset();
//     dispatch(clearOutreachFormState());
//   };

//   const handleResetOffice = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     officeForm.reset();
//     dispatch(clearOutreachFormState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isOfficeRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isOfficeRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.primary.dark
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isGeneralRoute ? 'Outreach Form' : 'Outreach Form - Office Use Only'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isGeneralRoute ? 'For documenting outreach services' : 'For office use only'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearOutreachFormState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => dispatch(clearOutreachFormState())}>
//             {error}
//           </Alert>
//         )}
//         {isOfficeRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This outreach form has already been filled for Office Use Only.
//           </Alert>
//         )}
//         {clientsError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
//             {clientsError}
//           </Alert>
//         )}
//         {staffError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
//             {staffError}
//           </Alert>
//         )}

//         {isGeneralRoute && (
//           <form onSubmit={generalForm.handleSubmit(onSubmitGeneral)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_of_outreach"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Outreach"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.date_of_outreach}
//                         helperText={generalForm.formState.errors.date_of_outreach?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="client_name"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           size="small"
//                           options={clientsList}
//                           getOptionLabel={(option: Client) => option.label}
//                           value={clientsList.find((client) => client.label === field.value) || null}
//                           onChange={(_, newValue) => field.onChange(newValue?.label || '')}
//                           disabled={isClientsLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               label="Client's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 )
//                               }}
//                               sx={{
//                                 '& .MuiInputBase-root': {
//                                   backgroundColor:
//                                     theme.palette.mode === 'light' ? '#fff' : '#424242'
//                                 },
//                                 '& .MuiInputLabel-root': {
//                                   color: theme.palette.text.secondary
//                                 }
//                               }}
//                               error={!!generalForm.formState.errors.client_name}
//                               helperText={generalForm.formState.errors.client_name?.message}
//                             />
//                           )}
//                           noOptionsText={
//                             isClientsLoading ? 'Loading clients...' : 'No clients available'
//                           }
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="support_worker_name"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           size="small"
//                           options={supportWorkers}
//                           getOptionLabel={(option: StaffMember) => option.name}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => field.onChange(newValue?.name || '')}
//                           disabled={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 )
//                               }}
//                               sx={{
//                                 '& .MuiInputBase-root': {
//                                   backgroundColor:
//                                     theme.palette.mode === 'light' ? '#fff' : '#424242'
//                                 },
//                                 '& .MuiInputLabel-root': {
//                                   color: theme.palette.text.secondary
//                                 }
//                               }}
//                               error={!!generalForm.formState.errors.support_worker_name}
//                               helperText={generalForm.formState.errors.support_worker_name?.message}
//                             />
//                           )}
//                           noOptionsText={
//                             staffLoading
//                               ? 'Loading support workers...'
//                               : 'No support workers available'
//                           }
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Type of Outreach Service Provided
//                     </Typography>
//                     <Controller
//                       name="service_type"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Home Visit"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Home Visit
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Community Support"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Community Support
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Other"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {generalForm.formState.errors.service_type && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {generalForm.formState.errors.service_type.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {service_type === 'Other' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="other_service_type"
//                         control={generalForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Please Specify Other Service Type"
//                             fullWidth
//                             margin="normal"
//                             sx={{
//                               '& .MuiInputBase-root': {
//                                 backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                               },
//                               '& .MuiInputLabel-root': {
//                                 color: theme.palette.text.secondary
//                               }
//                             }}
//                             {...field}
//                             error={!!generalForm.formState.errors.other_service_type}
//                             helperText={generalForm.formState.errors.other_service_type?.message}
//                           />
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaTools
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of the Outreach"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.description}
//                         helperText={generalForm.formState.errors.description?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="goals"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Goals of the Outreach"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.goals}
//                         helperText={generalForm.formState.errors.goals?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was the Outreach Successful?
//                     </Typography>
//                     <Controller
//                       name="was_successful"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {generalForm.formState.errors.was_successful && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {generalForm.formState.errors.was_successful.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                   {was_successful === 'No' && (
//                     <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
//                       <Controller
//                         name="explanation"
//                         control={generalForm.control}
//                         render={({ field }) => (
//                           <TextField
//                             size="small"
//                             label="Explain Why Outreach Was Not Successful"
//                             multiline
//                             rows={isMobile ? 2 : 3}
//                             fullWidth
//                             margin="normal"
//                             sx={{
//                               '& .MuiInputBase-root': {
//                                 backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                               },
//                               '& .MuiInputLabel-root': {
//                                 color: theme.palette.text.secondary
//                               }
//                             }}
//                             {...field}
//                             error={!!generalForm.formState.errors.explanation}
//                             helperText={generalForm.formState.errors.explanation?.message}
//                           />
//                         )}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetGeneral}
//                 disabled={!generalForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Outreach Form'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isOfficeRoute && (
//           <form onSubmit={officeForm.handleSubmit(onSubmitOffice)}>
//             {/* Office Use Only */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Office Use Only
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="support_worker_name_details"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <FormControl fullWidth margin="normal">
//                         <Autocomplete
//                           size="small"
//                           options={supportWorkers}
//                           getOptionLabel={(option: StaffMember) => option.name}
//                           value={
//                             supportWorkers.find((worker) => worker.name === field.value) || null
//                           }
//                           onChange={(_, newValue) => field.onChange(newValue?.name || '')}
//                           disabled={staffLoading}
//                           renderInput={(params) => (
//                             <TextField
//                               {...params}
//                               label="Support Worker's Name"
//                               InputProps={{
//                                 ...params.InputProps,
//                                 startAdornment: (
//                                   <InputAdornment position="start">
//                                     <FaUser size={16} />
//                                   </InputAdornment>
//                                 )
//                               }}
//                               sx={{
//                                 '& .MuiInputBase-root': {
//                                   backgroundColor:
//                                     theme.palette.mode === 'light' ? '#fff' : '#424242'
//                                 },
//                                 '& .MuiInputLabel-root': {
//                                   color: theme.palette.text.secondary
//                                 }
//                               }}
//                               error={!!officeForm.formState.errors.support_worker_name_details}
//                               helperText={
//                                 officeForm.formState.errors.support_worker_name_details?.message
//                               }
//                             />
//                           )}
//                           noOptionsText={
//                             staffLoading
//                               ? 'Loading support workers...'
//                               : 'No support workers available'
//                           }
//                         />
//                       </FormControl>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="signature"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.signature}
//                         helperText={officeForm.formState.errors.signature?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_completed"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.date_completed}
//                         helperText={officeForm.formState.errors.date_completed?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="notes"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Notes"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.notes}
//                         helperText={officeForm.formState.errors.notes?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="action_taken"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Action Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.action_taken}
//                         helperText={officeForm.formState.errors.action_taken?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetOffice}
//                 disabled={!officeForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !outreachId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Office Details'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default OutreachForm;

import { yupResolver } from '@hookform/resolvers/yup';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FaCalendarAlt, FaCheckCircle, FaFileAlt, FaTools, FaUndo, FaUser } from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { OutreachForm as OutreachFormType } from 'slices/NdisSlices/carporateServices/feedbackAndManagementListSlice';
import {
  clearOutreachFormState,
  OutreachFormData,
  submitOutreachForm
} from 'slices/NdisSlices/reportAllForms/outreachFormSlice';
import { fetchParticipantsList } from 'slices/HomeTilesSlices';
import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';
import * as yup from 'yup';

// Validation schemas
const generalSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_outreach: yup.string().required('Date of outreach is required'),
    client_name: yup.string().required('Client name is required'),
    support_worker_name: yup.string().required('Support worker name is required'),
    service_type: yup.string().required('Type of outreach service is required'),
    other_service_type: yup.string().when('service_type', {
      is: 'Other',
      then: (schema) => schema.required('Please specify other service type'),
      otherwise: (schema) => schema.optional().default('')
    }),
    description: yup.string().required('Description of outreach is required'),
    goals: yup.string().required('Goals of outreach are required'),
    was_successful: yup.string().required('Please specify if outreach was successful'),
    explanation: yup.string().when('was_successful', {
      is: 'No',
      then: (schema) => schema.required('Please explain why outreach was not successful'),
      otherwise: (schema) => schema.optional().default('')
    }),
    support_worker_name_details: yup.string().optional().default(''),
    signature: yup.string().optional().default(''),
    date_completed: yup.string().optional().default(''),
    client_email: yup.string().optional().default(''),
    group_id: yup.string().optional().default(''),
    service_name_id: yup.string().optional().default(''),
    notes: yup.string().optional().default(''),
    action_taken: yup.string().optional().default(''),
    resolved: yup.string().optional().default('')
  })
  .required() as yup.ObjectSchema<OutreachFormData>;

const officeSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_outreach: yup.string().optional().default(''),
    client_name: yup.string().optional().default(''),
    support_worker_name: yup.string().optional().default(''),
    service_type: yup.string().optional().default(''),
    other_service_type: yup.string().optional().default(''),
    description: yup.string().optional().default(''),
    goals: yup.string().optional().default(''),
    was_successful: yup.string().optional().default(''),
    explanation: yup.string().optional().default(''),
    support_worker_name_details: yup.string().required('Support worker name (details) is required'),
    signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    client_email: yup.string().optional().default(''),
    group_id: yup.string().optional().default(''),
    service_name_id: yup.string().optional().default(''),
    notes: yup.string().optional().default(''),
    action_taken: yup.string().optional().default(''),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the issue is resolved')
      .required('Please specify if the issue is resolved')
  })
  .required() as yup.ObjectSchema<OutreachFormData>;

interface Client {
  label: string;
  id: number;
  email: string;
}

interface StaffMember {
  name: string;
  email: string;
}

interface OutreachFormProps {
  initialData?: OutreachFormType;
  onClose?: () => void;
}

const OutreachForm: React.FC<OutreachFormProps> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.outreachForm);
  const navigate = useNavigate();
  const location = useLocation();

  // Redux state data
  const selectedProjectId = useTypedSelector(
    (state: RootState) => state.homeTilesServices.selectedProjectId
  );
  const selectedServiceTitle = useTypedSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle
  );
  const participantsList = useTypedSelector(
    (state: RootState) => state?.homeTilesServices?.participants
  ) || { participants_list: [] };
  const supportWorkers = useTypedSelector((state: RootState) =>
    (state.calendarEvents.staffList?.['Support worker'] || []).map((worker: any) => ({
      name: worker.name,
      email: worker.email || '' // Fallback to empty string if email is missing
    }))
  ) as StaffMember[];
  const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    label?: string;
    id?: number;
    email?: string;
  };
  const loginInfo = localStorage.getItem('user-details');
  const userDetails = loginInfo ? JSON.parse(loginInfo) : null;

  // Prepare clients list, ensuring selectedClient is included
  const clientsList = useMemo(() => {
    const list =
      participantsList.participants_list?.map(
        (participant: { name: string; email: string }, index: number) => ({
          label: participant.name || `Client ${index + 1}`,
          id: index + 1,
          email: participant.email
        })
      ) || [];
    // Add selectedClient if it exists and is not already in the list
    if (
      selectedClient?.label &&
      selectedClient?.email &&
      !list.some((client) => client.label === selectedClient.label)
    ) {
      list.push({
        label: selectedClient.label,
        id: selectedClient.id || list.length + 1,
        email: selectedClient.email
      });
    }
    return list;
  }, [participantsList.participants_list, selectedClient]);

  // Find default client and support worker for Autocomplete
  const defaultClient =
    clientsList.find(
      (client) => client.label === (initialData?.client_name || selectedClient?.label)
    ) || null;
  const defaultSupportWorker =
    supportWorkers.find(
      (worker) => worker.name === (initialData?.support_worker_name || userDetails?.name)
    ) || null;
  const defaultSupportWorkerDetails =
    supportWorkers.find((worker) => worker.name === (initialData?.sw_name || userDetails?.name)) ||
    null;

  // State for client and staff loading/errors
  const [isClientsLoading, setIsClientsLoading] = useState(false);
  const [clientsError, setClientsError] = useState<string | null>(null);
  const [staffError, setStaffError] = useState<string | null>(null);

  // Check if Office Use Only or Follow-Up form is already filled
  const [alreadyFilled, setAlreadyFilled] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'feedbacks';
  const outreachId = initialData?.id || undefined;

  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' &&
    searchParams.get('tab') === 'feedbacks';

  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      const isResolved = String(initialData?.resolved).toLowerCase() === 'yes';

      setAlreadyFilled(isResolved);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Fetch participants
  useEffect(() => {
    if (
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      setIsClientsLoading(true);
      dispatch(
        fetchParticipantsList({
          group_id: selectedProjectId || '',
          service_name_id: selectedServiceTitle || '',
          nested_component_id: location.pathname,
          email: userDetails.email,
          roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
          client_name: ''
        })
      )
        .unwrap()
        .then(() => {
          setIsClientsLoading(false);
        })
        .catch((error: unknown) => {
          setIsClientsLoading(false);
          setClientsError('Failed to load clients. Please try again later.');
        });
    } else {
      setIsClientsLoading(false);
    }
  }, [selectedProjectId]);

  // Fetch staff
  useEffect(() => {
    if (
      selectedClient?.label &&
      selectedProjectId &&
      selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role?.length > 0
    ) {
      const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
      const payload = {
        group_id: selectedProjectId,
        service_name_id: selectedServiceTitle.replace(' ', '_'),
        nested_component_id: 'Staff_List',
        email_loggedIn_userEmail: userDetails.email,
        roles: userDetails.role?.map((r: { role_id: string }) => r.role_id) || [],
        client_name: selectedClient.label?.replace(' ', '_') || '',
        approved_user: approvedUser,
        curr_loggIn_userRoles: userDetails?.name || ''
      };
      dispatch(fetchStaffByRoles(payload)).catch((error: unknown) => {
        setStaffError('Failed to load support workers. Please try again later.');
      });
    }
  }, [selectedClient?.label]);

  const isGeneralRoute = location.pathname === '/outreach';
  const isOfficeRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'feedbacks';

  // Current datetime as default
  const defaultDateTime = new Date().toISOString().split('T')[0];

  // Use separate useForm hooks for each route
  const generalForm = useForm<OutreachFormData>({
    resolver: yupResolver<OutreachFormData>(generalSchema),
    defaultValues: {
      id: initialData?.id || '',
      date_of_outreach: initialData?.date_of_outreach || defaultDateTime,
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || userDetails?.name || '',
      service_type: initialData?.type_of_outreach || '',
      other_service_type:
        initialData?.type_of_outreach &&
        !['Home Visit', 'Community Support'].includes(initialData.type_of_outreach)
          ? initialData.type_of_outreach
          : '',
      description: initialData?.description || '',
      goals: initialData?.goals || '',
      was_successful: initialData?.successful || '',
      explanation: initialData?.explanation || '',
      support_worker_name_details: '',
      signature: '',
      date_completed: '',
      client_email: selectedClient?.email || '',
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      notes: '',
      action_taken: '',
      resolved: initialData?.resolved || ''
    }
  });

  const officeForm = useForm<OutreachFormData>({
    resolver: yupResolver<OutreachFormData>(officeSchema),
    defaultValues: {
      id: initialData?.id || '',
      date_of_outreach: initialData?.date_of_outreach || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || '',
      service_type: initialData?.type_of_outreach || '',
      other_service_type:
        initialData?.type_of_outreach &&
        !['Home Visit', 'Community Support'].includes(initialData.type_of_outreach)
          ? initialData.type_of_outreach
          : '',
      description: initialData?.description || '',
      goals: initialData?.goals || '',
      was_successful: initialData?.successful || '',
      explanation: initialData?.explanation || '',
      support_worker_name_details: initialData?.sw_name || userDetails?.name || '',
      signature: initialData?.sw_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      client_email: selectedClient?.email || '',
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      notes: initialData?.notes || '',
      action_taken: initialData?.action_taken || '',
      resolved: initialData?.resolved || ''
    }
  });

  const service_type = generalForm.watch('service_type');
  const was_successful = generalForm.watch('was_successful');

  // Update client_email when client_name changes
  useEffect(() => {
    const selectedClientFromList = clientsList.find(
      (client) => client.label === generalForm.getValues('client_name')
    );
    if (selectedClientFromList) {
      generalForm.setValue('client_email', selectedClientFromList.email);
    }
  }, [generalForm.watch('client_name'), clientsList, generalForm]);

  useEffect(() => {
    const selectedClientFromList = clientsList.find(
      (client) => client.label === officeForm.getValues('client_name')
    );
    if (selectedClientFromList) {
      officeForm.setValue('client_email', selectedClientFromList.email);
    }
  }, [officeForm.watch('client_name'), clientsList, officeForm]);

  const onSubmitGeneral = async (data: OutreachFormData) => {
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    const payload: OutreachFormData = {
      ...data,
      client_email,
      support_worker_name_details: '',
      signature: '',
      date_completed: '',
      notes: '',
      action_taken: '',
      resolved: ''
    };

    dispatch(submitOutreachForm({ formData: payload }))
      .unwrap()
      .then(() => {
        generalForm.reset();
        setTimeout(() => dispatch(clearOutreachFormState()), 5000);
      });
  };

  const onSubmitOffice = async (data: OutreachFormData) => {
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    const payload: OutreachFormData = {
      id: outreachId,
      ...data,
      client_email
    };

    dispatch(submitOutreachForm({ formData: payload, initialData }))
      .unwrap()
      .then(() => {
        officeForm.reset();
        setTimeout(() => dispatch(clearOutreachFormState()), 5000);
        if (onClose) {
          onClose();
        }
      });
  };

  const handleResetGeneral = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    generalForm.reset();
    dispatch(clearOutreachFormState());
  };

  const handleResetOffice = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    officeForm.reset({
      id: initialData?.id || '',
      date_of_outreach: initialData?.date_of_outreach || '',
      client_name: initialData?.client_name || selectedClient?.label || '',
      support_worker_name: initialData?.support_worker_name || '',
      service_type: initialData?.type_of_outreach || '',
      other_service_type:
        initialData?.type_of_outreach &&
        !['Home Visit', 'Community Support'].includes(initialData.type_of_outreach)
          ? initialData.type_of_outreach
          : '',
      description: initialData?.description || '',
      goals: initialData?.goals || '',
      was_successful: initialData?.successful || '',
      explanation: initialData?.explanation || '',
      support_worker_name_details: initialData?.sw_name || userDetails?.name || '',
      signature: initialData?.sw_signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      client_email: selectedClient?.email || '',
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      notes: initialData?.notes || '',
      action_taken: initialData?.action_taken || '',
      resolved: initialData?.resolved || ''
    });
    dispatch(clearOutreachFormState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isOfficeRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isOfficeRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.primary.dark
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isGeneralRoute ? 'Outreach Form' : 'Outreach Form - Office Use Only'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isGeneralRoute ? 'For documenting outreach services' : 'For office use only'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearOutreachFormState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => dispatch(clearOutreachFormState())}>
            {error}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This outreach form has already been resolved or filled for Office Use Only.
          </Alert>
        )}
        {clientsError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
            {clientsError}
          </Alert>
        )}
        {staffError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setStaffError(null)}>
            {staffError}
          </Alert>
        )}

        {isGeneralRoute && (
          <form onSubmit={generalForm.handleSubmit(onSubmitGeneral)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_of_outreach"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Outreach"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.date_of_outreach}
                        helperText={generalForm.formState.errors.date_of_outreach?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="client_name"
                    control={generalForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          size="small"
                          options={clientsList}
                          getOptionLabel={(option: Client) => option.label}
                          value={clientsList.find((client) => client.label === field.value) || null}
                          onChange={(_, newValue) => field.onChange(newValue?.label || '')}
                          disabled={isClientsLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Client's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                )
                              }}
                              sx={{
                                '& .MuiInputBase-root': {
                                  backgroundColor:
                                    theme.palette.mode === 'light' ? '#fff' : '#424242'
                                },
                                '& .MuiInputLabel-root': {
                                  color: theme.palette.text.secondary
                                }
                              }}
                              error={!!generalForm.formState.errors.client_name}
                              helperText={generalForm.formState.errors.client_name?.message}
                            />
                          )}
                          noOptionsText={
                            isClientsLoading ? 'Loading clients...' : 'No clients available'
                          }
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="support_worker_name"
                    control={generalForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          size="small"
                          options={supportWorkers}
                          getOptionLabel={(option: StaffMember) => option.name}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                          disabled={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                )
                              }}
                              sx={{
                                '& .MuiInputBase-root': {
                                  backgroundColor:
                                    theme.palette.mode === 'light' ? '#fff' : '#424242'
                                },
                                '& .MuiInputLabel-root': {
                                  color: theme.palette.text.secondary
                                }
                              }}
                              error={!!generalForm.formState.errors.support_worker_name}
                              helperText={generalForm.formState.errors.support_worker_name?.message}
                            />
                          )}
                          noOptionsText={
                            staffLoading
                              ? 'Loading support workers...'
                              : 'No support workers available'
                          }
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Type of Outreach Service Provided
                    </Typography>
                    <Controller
                      name="service_type"
                      control={generalForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2,
                            flexWrap: 'wrap'
                          }}
                        >
                          <FormControlLabel
                            value="Home Visit"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Home Visit
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Community Support"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Community Support
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Other"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {generalForm.formState.errors.service_type && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {generalForm.formState.errors.service_type.message}
                      </Typography>
                    )}
                  </FormControl>
                  {service_type === 'Other' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="other_service_type"
                        control={generalForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Please Specify Other Service Type"
                            fullWidth
                            margin="normal"
                            sx={{
                              '& .MuiInputBase-root': {
                                backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                              },
                              '& .MuiInputLabel-root': {
                                color: theme.palette.text.secondary
                              }
                            }}
                            {...field}
                            error={!!generalForm.formState.errors.other_service_type}
                            helperText={generalForm.formState.errors.other_service_type?.message}
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>

            {/* Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaTools
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of the Outreach"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.description}
                        helperText={generalForm.formState.errors.description?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="goals"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Goals of the Outreach"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.goals}
                        helperText={generalForm.formState.errors.goals?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was the Outreach Successful?
                    </Typography>
                    <Controller
                      name="was_successful"
                      control={generalForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {generalForm.formState.errors.was_successful && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {generalForm.formState.errors.was_successful.message}
                      </Typography>
                    )}
                  </FormControl>
                  {was_successful === 'No' && (
                    <Box sx={{ pl: isMobile ? 2 : 4, mt: 1 }}>
                      <Controller
                        name="explanation"
                        control={generalForm.control}
                        render={({ field }) => (
                          <TextField
                            size="small"
                            label="Explain Why Outreach Was Not Successful"
                            multiline
                            rows={isMobile ? 2 : 3}
                            fullWidth
                            margin="normal"
                            sx={{
                              '& .MuiInputBase-root': {
                                backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                              },
                              '& .MuiInputLabel-root': {
                                color: theme.palette.text.secondary
                              }
                            }}
                            {...field}
                            error={!!generalForm.formState.errors.explanation}
                            helperText={generalForm.formState.errors.explanation?.message}
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetGeneral}
                disabled={!generalForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Outreach Form'}
              </Button>
            </Box>
          </form>
        )}

        {isOfficeRoute && (
          <form onSubmit={officeForm.handleSubmit(onSubmitOffice)}>
            {/* Office Use Only */}
            {isFollowUpRoute && alreadyFilled && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                This outreach form has already been resolved or filled for Office Use Only.
              </Alert>
            )}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Office Use Only
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker_name_details"
                    control={officeForm.control}
                    render={({ field }) => (
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          size="small"
                          options={supportWorkers}
                          getOptionLabel={(option: StaffMember) => option.name}
                          value={
                            supportWorkers.find((worker) => worker.name === field.value) || null
                          }
                          onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                          disabled={staffLoading}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Support Worker's Name"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <FaUser size={16} />
                                  </InputAdornment>
                                )
                              }}
                              sx={{
                                '& .MuiInputBase-root': {
                                  backgroundColor:
                                    theme.palette.mode === 'light' ? '#fff' : '#424242'
                                },
                                '& .MuiInputLabel-root': {
                                  color: theme.palette.text.secondary
                                }
                              }}
                              error={!!officeForm.formState.errors.support_worker_name_details}
                              helperText={
                                officeForm.formState.errors.support_worker_name_details?.message
                              }
                            />
                          )}
                          noOptionsText={
                            staffLoading
                              ? 'Loading support workers...'
                              : 'No support workers available'
                          }
                        />
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="signature"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.signature}
                        helperText={officeForm.formState.errors.signature?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_completed"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.date_completed}
                        helperText={officeForm.formState.errors.date_completed?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Issue Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={officeForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {officeForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {officeForm.formState.errors.resolved.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="notes"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Notes"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.notes}
                        helperText={officeForm.formState.errors.notes?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="action_taken"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Action Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.action_taken}
                        helperText={officeForm.formState.errors.action_taken?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetOffice}
                disabled={!officeForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !outreachId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Office Details'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default OutreachForm;
